/* ==========================================================================
   SilkSilQ 滚动动画系统 v3.1
   变更自 v3：引入 ss-no-animate 全局豁免 class
   - 叶子元素用法：给不想被动画接管的单个元素加 class="ss-no-animate"
   - 容器用法：给容器加 class="ss-no-animate"，容器内所有后代都豁免
   ========================================================================== */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* -----------------------------------------------------------------------
     配置
     ----------------------------------------------------------------------- */

  var AUTO_SELECTORS = [
    'h1', 'h2', 'h3',
    '[class*="-heading-"]',
    '[class*="-title-"]',
    '[class*="-eyebrow-"]',
    '[class*="-card-"]',
    '[class*="-tile-"]',
    '[class*="-grid-"]',
    '[class*="-list-"]',
    '[class*="-header-"]',
    '[class*="-summary-"]',
    '[class*="-carousel-wrap"]'
  ].join(', ');

  var HARD_EXCLUDE_CONTAINERS = [
    'header',
    'nav',
    '.swiper',
    '.swiper-wrapper',
    '.swiper-slide',
    '[class*="ss-marquee-"]',
    '[class*="featured-image-slider"]',
    '[class*="featured-product-slider"]',
    '[class*="slideshow-slider"]',
    '[class*="slideshow-slide"]',
    '[class*="menu-list"]',
    '[class*="menu-item"]',
    '[class*="submenu"]'
  ].join(', ');

  // 祖先匹配：任何祖先匹配下列选择器，后代全部豁免
  var HARD_EXCLUDE_PARENT_SELECTORS = [
    '[class*="-expand-"]',
    '[class*="-compare-"]',
    '[class*="sss-panel-"]',
    '[class*="sss-tab-"]',
    '[class*="silksilq-tab-"]',
    '[class*="silksilq-tabs-list"]',
    '.ss-no-animate'                  // 通用豁免（容器用法）
  ].join(', ');

  // 自身匹配：元素自己带下列任一 class 则豁免
  var HARD_EXCLUDE_CLASSES = [
    'scroll-trigger',
    'animate--fade-in',
    'animate--slide-in',
    'motion-reduce',
    'ss-no-animate'                   // 通用豁免（叶子用法）
  ];

  /* -----------------------------------------------------------------------
     工具
     ----------------------------------------------------------------------- */

  function shouldSkipElement(el) {
    if (el.hasAttribute('data-animate')) return true;
    if (el.hasAttribute('data-animate-stagger')) return true;
    if (el.parentElement && el.parentElement.hasAttribute('data-animate-stagger')) return true;
    if (el.closest(HARD_EXCLUDE_CONTAINERS)) return true;
    if (el.closest(HARD_EXCLUDE_PARENT_SELECTORS)) return true;
    for (var i = 0; i < HARD_EXCLUDE_CLASSES.length; i++) {
      if (el.classList.contains(HARD_EXCLUDE_CLASSES[i])) return true;
    }
    return false;
  }

  /* -----------------------------------------------------------------------
     核心
     ----------------------------------------------------------------------- */

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0,
    rootMargin: '0px 0px 0px 0px'
  });

  function markAndObserve() {
    var sections = document.querySelectorAll('[data-ss-animate="true"]');
    sections.forEach(function (section) {
      var candidates = section.querySelectorAll(AUTO_SELECTORS);
      candidates.forEach(function (el) {
        if (!shouldSkipElement(el) && !el.classList.contains('ss-auto-animate')) {
          el.classList.add('ss-auto-animate');
          observer.observe(el);
        }
      });
    });

    // 手动标注的 (data-animate / data-animate-stagger) 全站生效
    document.querySelectorAll('[data-animate]:not(.is-visible), [data-animate-stagger]:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* -----------------------------------------------------------------------
     动态内容监听（Recently Viewed 等 JS 生成的卡片）
     ----------------------------------------------------------------------- */

  function watchForDynamicContent() {
    var sections = document.querySelectorAll('[data-ss-animate="true"]');
    var domObserver = new MutationObserver(function () {
      markAndObserve();
    });

    sections.forEach(function (section) {
      domObserver.observe(section, { childList: true, subtree: true });
    });
  }

  /* -----------------------------------------------------------------------
     启动
     ----------------------------------------------------------------------- */

  function init() {
    markAndObserve();
    watchForDynamicContent();

    document.addEventListener('shopify:section:load', function () {
      markAndObserve();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();